function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './Switch.css';
import React, { useEffect } from 'react';
import { canUseDOM, get, getDictionaryItem } from '../../utils';
import addQueryString, { removeQueryString, splitter } from './index';
import { useHistory, useLocation } from 'react-router-dom';
import { qsToObject } from '../../utils/querystring';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import { isNil } from '../../utils/IsNil';
const replaceUrlPluses = function () {
  let str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (str) {
    let arr = str.split('');
    let plusIndexes = [];
    arr.forEach((item, index) => {
      if (item === '+') {
        plusIndexes.push(index);
      }
    });
    if (str.includes('+') && str.includes('%20')) {
      return str.replace(/\%20/g, ' ');
    } else {
      let newStr = str;
      let newStrArr = str.split('');
      plusIndexes.forEach((el, i) => {
        // 5++days -> 5+ days
        if (el + 1 === plusIndexes[i + 1]) {
          newStrArr[el + 1] = ' ';
          newStr = newStrArr.join('');
          // 1+day -> 1 day
        } else if (plusIndexes.length === 1 && newStrArr[el + 1] !== ' ') {
          newStrArr[el] = ' ';
          newStr = newStrArr.join('');
          // 5+ day
        } else if (plusIndexes.length === 1 && newStrArr[el + 1] === ' ') {
          return str;
        }
        //business+events;,leisure+events;art+&+events
        else {
          newStrArr[el] = ' ';
          newStr = newStrArr.join('');
        }
      });
      return newStr;
    }
  }
  return str;
};
const sortFilters = (arr, pinnedArray) => {
  if (arr.length !== 0) {
    const sortedArray = arr.map(el => pinnedArray.includes(el.key) ? _objectSpread(_objectSpread({}, el), {}, {
      pinned: true
    }) : el);
    return sortedArray.sort(first => first.pinned ? -1 : 1);
  }
};
export const createFacetsWithPinnedLogic = (facets, pinnedArray) => {
  let filteredOptions = [];
  if (facets) {
    filteredOptions = Object.keys(facets).map(item => ({
      key: item,
      label: facets[item],
      name: item
    }));
  }
  return sortFilters(filteredOptions, pinnedArray);
};
const Switch = _ref => {
  let {
    fields,
    facets,
    setFilter,
    facetsName,
    selectAllLabel,
    clearAlllFilters,
    isTagPage,
    dictionary,
    buttonsDictionary,
    analytics,
    pinned,
    setIsTypeSetToUrl,
    getFilterValue,
    rtl,
    resetAllFiltersCallback,
    autoWidth
  } = _ref;
  const location = useLocation();
  const queryParams = qsToObject(location.search);
  const selectedTagsToDisplay = get(fields, 'preselectedTags.values');
  const filterName = get(fields, 'name');
  const [filteredOptions, setFilteredOptions] = React.useState(canUseDOM ? createFacetsWithPinnedLogic(facets, pinned) : []);
  const filterType = get(fields, 'fieldNameItem.item.fieldName.value');
  const showSelectAllOption = get(fields, 'showSelectAllOption.jss.value');
  const type = get(fields, 'fieldTypeItem.item.fieldType.value') === 'Toggle Single Select' ? 'radio' : 'checkbox';
  let history = useHistory();
  const checkboxes = React.useRef();
  useEffect(() => {
    if (clearAlllFilters) {
      if (selectedTagsToDisplay && selectedTagsToDisplay.length !== 0) {
        const preselectedTags = selectedTagsToDisplay.map(tag => get(tag, 'title.value') || get(tag, 'name'));
        addQueryString(facetsName, replaceUrlPluses(preselectedTags.join(',')), history);
        getFilterValue && getFilterValue(fields.name, facetsName, replaceUrlPluses(preselectedTags.join(',')));
        setFilter();
        resetAllFiltersCallback();
      } else if (pinned) {
        addQueryString(facetsName, replaceUrlPluses(pinned.join(',')), history);
        getFilterValue && getFilterValue(fields.name, facetsName, replaceUrlPluses(pinned.join(',')));
        setFilter();
        resetAllFiltersCallback();
      } else {
        const checkboxesArray = checkboxes.current.querySelectorAll('.fp__checkbox');
        for (let i = 0; i <= checkboxesArray.length - 1; i++) {
          checkboxesArray[i].checked = false;
        }
        removeQueryString(facetsName, history);
        getFilterValue && getFilterValue(fields.name, facetsName, null);
      }
    }
  }, [clearAlllFilters]);
  useEffect(() => {
    const queries = queryParams[`${filterType}`];
    if (selectedTagsToDisplay && selectedTagsToDisplay.length !== 0) {
      const preselectedTags = selectedTagsToDisplay.map(tag => get(tag, 'title.value') || get(tag, 'name'));
      if (!queries) {
        addQueryString(facetsName, replaceUrlPluses(preselectedTags.join(',')), history);
        setFilter(true);
      }
    }
  }, []);
  const addNewQueryString = () => {
    const queries = queryParams[`${filterType}`];
    if (!queries && filteredOptions && filteredOptions.length) {
      addQueryString(facetsName, filteredOptions[0].key, history);
      setIsTypeSetToUrl(true);
    }
  };
  const buttonHistoryHandler = () => {
    const urlParams = new URLSearchParams(canUseDOM ? window.location.search : undefined);
    const typeFromUrl = urlParams.get('type');
    if (isNil(typeFromUrl)) {
      addNewQueryString();
    }
  };
  useEffect(() => {
    addNewQueryString();
  }, [filteredOptions]);
  useEffect(() => {
    if (canUseDOM) {
      window.addEventListener('popstate', buttonHistoryHandler);
    }
    return () => {
      removeQueryString(facetsName, history);
      window.addEventListener('popstate', buttonHistoryHandler);
    };
  }, []);
  const setChecked = (key, filterType, index) => {
    let queries = queryParams[`${filterType}`];
    queries = queries && replaceUrlPluses(queries);
    let isChecked = false;
    if (index === 0 && isTagPage && !queries) {
      addQueryString(facetsName, replaceUrlPluses(key), history);
      setFilter();
      isChecked = true;
    }
    queries && queries.split(';,;').map(item => {
      if (replaceUrlPluses(item) === key) {
        isChecked = true;
      }
    });
    return isChecked;
  };
  useEffect(() => {
    setFilteredOptions(createFacetsWithPinnedLogic(facets, pinned));
  }, [facets]);
  const translatedKey = key => {
    if (isTagPage) {
      return getDictionaryItem(dictionary, `Type.${key}`);
    } else {
      return getDictionaryItem(buttonsDictionary, key) || key;
    }
  };
  const submitFilters = e => {
    const checkboxesArray = checkboxes.current.querySelectorAll('.fp__checkbox');
    let selectedCheckboxes = [];
    for (let i = 0; i <= checkboxesArray.length - 1; i++) {
      if (checkboxesArray[i].checked) {
        selectedCheckboxes.push(checkboxesArray[i].value);
      }
    }
    selectedCheckboxes = selectedCheckboxes.join(splitter);
    addQueryString(facetsName, replaceUrlPluses(selectedCheckboxes), history);
    setFilter();
    getFilterValue && getFilterValue(fields.name, facetsName, replaceUrlPluses(selectedCheckboxes));
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    autoWidth: autoWidth
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter-toggle-multi-select switch"
  }, /*#__PURE__*/React.createElement("div", {
    ref: checkboxes,
    className: `g-checkbox g-checkbox--mob-scroll ${type === 'radio' ? 'g-checkbox-notick' : ''}`
  }, filteredOptions && filteredOptions.map((item, index) => {
    const {
      key
    } = item;
    return /*#__PURE__*/React.createElement("div", {
      key: key + index,
      className: "g-checkbox__item"
    }, /*#__PURE__*/React.createElement("input", {
      tabIndex: 0,
      value: key,
      defaultChecked: setChecked(key, filterType, index),
      checked: setChecked(key, filterType, index),
      type: type,
      className: `fp__checkbox`,
      id: `gct1-${key + index}`,
      name: "gct1",
      title: translatedKey(key),
      onChange: e => {
        tealiumClickFunc(tealiumMergeClickData(analytics.filterAnalytics, analytics.params), `${filterName}: ${key} `);
        submitFilters(e);
      },
      onKeyPress: event => {
        if (event.key === 'Enter' || event.key === 'NumpadEnter') {
          event.preventDefault();
          event.target.checked = !event.target.checked;
          tealiumClickFunc(tealiumMergeClickData(analytics.filterAnalytics, analytics.params), `${filterName}: ${key} `);
          submitFilters(event);
        }
      }
    }), /*#__PURE__*/React.createElement("label", {
      className: "body-small g-checkbox__label",
      htmlFor: `gct1-${key + index}`
    }, translatedKey(key)));
  }), showSelectAllOption && /*#__PURE__*/React.createElement("div", {
    className: "g-checkbox__item"
  }, /*#__PURE__*/React.createElement("input", {
    value: selectAllLabel,
    defaultChecked: false,
    type: type,
    className: `select-all-fp__checkbox`,
    id: `gct1-select-all`,
    name: "selectAll",
    onChange: _ref2 => {
      let {
        currentTarget
      } = _ref2;
      const checkboxesArray = checkboxes.current.querySelectorAll('.fp__checkbox');
      let selectedCheckboxes = [];
      for (let i = 0; i <= checkboxesArray.length - 1; i++) {
        checkboxesArray[i].checked = true;
        selectedCheckboxes.push(checkboxesArray[i].value);
      }
      currentTarget.checked = false;
      selectedCheckboxes = selectedCheckboxes.toString();
      addQueryString(facetsName, replaceUrlPluses(selectedCheckboxes), history);
      setFilter();
    }
  }), /*#__PURE__*/React.createElement("label", {
    className: "body-small g-checkbox__label",
    htmlFor: `gct1-select-all`
  }, selectAllLabel)))));
};
const StyledWrapper = _ref3 => {
  let {
    children,
    rtl,
    autoWidth = false
  } = _ref3;
  return /*#__PURE__*/React.createElement("div", {
    className: `${commonStyles} ${rtl ? rtlStyle : ltrStyle} ${autoWidth ? 'col' : 'col-md-12'}`
  }, children);
};
export default Switch;
export const commonStyles = "cbfjhrm";
const ltrStyle = "l10ug17t";
const rtlStyle = "rkx7avf";